import { z } from 'zod';

import { percentageInput } from '@/_schemas/generic/percentage';

import { commissionPlansQuerySchema } from './commission-plans-query-schema';

export const commissionPlansUpdateSchema = commissionPlansQuerySchema
  .pick({ id: true, name: true, commission_earning_model: true })
  .extend({
    base_quota_amount: z.number(),
    default_one_time_rate: percentageInput.mutationSchema(),
    default_recurring_rate: percentageInput.mutationSchema(),
    bonus_amount: z.number(),
    bonus_threshold: z.number(),
  });

export type CommissionPlansUpdateSchema = z.infer<typeof commissionPlansUpdateSchema>;

export const commissionPlansCreateSchema = commissionPlansUpdateSchema.omit({ id: true });
export type CommissionPlansCreateSchema = z.infer<typeof commissionPlansCreateSchema>;
